import(/* webpackMode: "eager" */ "/vercel/path0/apps/scheduler-app/src/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
